import AppForm from '../../app-components/Form/AppForm';

Vue.component('tabs-form-import', {
    mixins: [AppForm],
    data: function() {
        return {
            form: {
                alias_name:  '' ,
                app_factories_id:  '' ,
                app_file_locations_id:  '' ,
                app_payment_id:  '' ,
                row_start:  1 ,
                read_sheet:  1 ,
                row_end:  1 ,
                column_maps:  [] ,
                factorySourceData:[],
                
            },
            tempFactory: null,
            headerPreview:  [] ,
            headerPreviewMapped: [],
            info:  {},
            payments:{
                type: Array,
                default:[ ]
            },
            paymentsNew:{
                type: Array,
                default:[ ]
            },
            fileInfo:{
                type: Object,
                default:{}
            },
            sheets:[],
            isReading: false,
           
        }
    },
    computed: {
        paymentVehicle: (app)=> (salut)=> {
            if (salut.vehicle_number_slug) {
                return app.paymentsNew[salut.vehicle_number_slug]||[]
            }
            return []
        },
        spreadsheetMatch (){
            if (this.form.factorySourceData.length>0) {
                
                return  this.form.factorySourceData?.reduce((result, row)=>{
                    if (row.app_payment_id) {
                        result.push(row.app_payment_id)
                    }
                    return result;
                }, [])
            }
            return []
        },
        databaseDoesNotMatch (){
            if (this.paymentsNew.length>0) {
                const spreadsheetMatch = this.spreadsheetMatch
                return  this.paymentsNew?.reduce((result, row)=>{
                    if (!spreadsheetMatch.includes(row.id)) {
                        result.not_match.push(row)
                    }else{
                        if (!row.verified) {
                            result.new_match.push(row)    
                        }
                        result.match.push(row)
                    }
                    return result;
                }, {
                    'match': [],
                    'new_match': [],
                    'not_match': [],
                })
            }
            return {
                'match': [],
                'new_match': [],
                'not_match': [],
            }
        },
        
    },
    methods:{
        isEqualDataPayment(typeData, index){
            if (this.form.factorySourceData[index]?.payment_selected !== null) {
                try {
                    const dataExcel = this.form.factorySourceData[index][this.headerPreviewMapped?.[typeData]?.column]||null
                    const dataDb = this.form.factorySourceData[index]?.payment_selected[typeData]||null
                    if (typeof dataExcel == 'string' && typeof dataDb=='string') {
                        return dataExcel.replaceAll(' ','').toLowerCase()==dataDb.replaceAll(' ','').toLowerCase()
                    }
                    return dataExcel==dataDb
                } catch (error) {
                    console.log("error", error)
                }
            }
            return false
        },
        getClassRow(index){
            if((this.form.factorySourceData[index]['payment_selected']==null || this.form.factorySourceData[index]['payment_selected'].length==0)){
                return 'table-danger'
            }
            const brutoIsNotEqual = this.isEqualDataPayment('netto_first', index) == false
            const potIsNotEqual = this.isEqualDataPayment('potongan', index) == false
            const nettoIsNotEqual = this.isEqualDataPayment('netto', index) == false
            if ( brutoIsNotEqual || potIsNotEqual || nettoIsNotEqual) {
                return 'table-warning'
            }
            return 'table-success'
        },
        readFile(){
            const superObj = this
            superObj.isReading = true
            superObj.form.factorySourceData = []
            superObj.payments = []

            superObj.form.factorySourceData = []
            superObj.headerPreview = superObj.form.column_maps

            const formData = new FormData();
            formData.append('app_file_locations_id', superObj.fileSelected);
            formData.append('app_factories_id', superObj.fileInfo.app_factories_id);

            formData.append('row_start', superObj.form.row_start);
            formData.append('read_sheet', superObj.form.read_sheet);
            formData.append('row_end', superObj.form.row_end);
            formData.append('column_maps', JSON.stringify(superObj.form.column_maps));
            const headers = { 'Content-Type': 'multipart/form-data' };

            axios.post(`${this.urlReadFile}`, formData, { headers }).then((res) => {

                const result = res.data
                const { data, info, payments, payments_new } = result
                this.form.factorySourceData = data
                // this.payments = payments
                this.paymentsNew = payments_new
                this.info = info
                superObj.isReading = false
            }).catch(function (error) {
                if (error.response) {
                    const { message, statusText } = error.response.data
                    const { message: axiosMessage } = error
                    superObj.$notify({
                        type: 'error',
                        title: 'Error!',
                        text: `${message} (${axiosMessage})`
                    });
                } else if (error.request) {
                  console.log(error.request);
                } else {
                  console.log('Error', error.message);
                }
                superObj.isReading = false
            
              });
        },
        getFileSelected(){
            const thisObj = this
            axios.get(`${this.urlFileLocation}/${this.fileSelected}/show`, {}, {  }).then((res) => {
                thisObj.fileInfo  = res?.data?.data||{}
                thisObj.form.app_factories_id  =  thisObj.fileInfo.app_factories_id;
                thisObj.form.app_file_locations_id  =  thisObj.fileSelected;

                thisObj.sheets  = thisObj.fileInfo.data?.sheets||[];
            
            }).catch(function (error) {
                if (error.response) {
                    const { message, statusText } = error.response.data
                    const { message: axiosMessage } = error
                    superObj.$notify({
                        type: 'error',
                        title: 'Error!',
                        text: `${message} (${axiosMessage})`
                    });
                } else if (error.request) {
                  console.log(error.request);
                } else {
                  console.log('Error', error.message);
                }
            
              });
        },
        resetFile(){
            this.form.factorySourceData = []
        },
        labelWithFormat ({ vehicle_number, farmer_name, driver_name, weighing_date, bruto, tara, potongan,netto }) {
            return `${vehicle_number}- <br> ${farmer_name}- ${driver_name}- ${weighing_date}- ${bruto}- ${tara}- ${potongan}- ${netto}`
            return `${vehicle_number} — [${weighing_date}]`
        },
        onSelectMatch (selectedOption, id) {
            this.form.factorySourceData[id].app_payment_id=selectedOption.id
        },
        onRemoveMatch (selectedOption, id) {
            this.form.factorySourceData[id].app_payment_id=null
        },
        exportAsExcelTesting () {
            const wb = XLSX.utils.book_new();
			let row1 = ["a", "b", "c"];
			let row2 = [1, 2, 3];
			let row3 = [
				{ v: 12, t: 'n', s: { font: { name: 'Courier', sz: 24 } } },
				{ v: 2333, t: 'n', s: { font: { bold: true, color: { rgb: 'FF0000' } } } },
				{ v: 'fill: color', t: 's', s: { fill: { fgColor: { rgb: 'E9E9E9' } } } },
				{ v: 'line\nbreak', t: 's', s: { alignment: { wrapText: true } } },
			]
			const ws = XLSX.utils.aoa_to_sheet([row1, row2, row3]);
			ws['!cols'] = [{ width: 100 }, { width: 20 }, { width: 20 }]
            // ws["!merges"] =[ { s: { r: 3, c: 0 }, e: { r: 4, c: 0 } }];
			XLSX.utils.book_append_sheet(wb, ws, 'browser-demo');
			XLSX.writeFile(wb, "xlsx-js-style-demo.xlsx");
        },
        exportAsExcel () {
            const wb = XLSX.utils.book_new();
       
            const datas = []
            datas.push([{ v: 'Data Spreadsheet',  t: 's', s: {  font: { sz: 13, bold: true } } } ])
            const headersTemp = this.headerPreviewMapped;
            headersTemp.farmer = {label: "Sopir (Rp/kg)", column: 'driver_price', id: 'driver_price'}
            headersTemp.driver = {label: "Petani (Rp/kg)", column: 'price', id: 'price'}
            headersTemp.extra = {label: "Extra (Rp/kg)", column: 'price_extra', id: 'price_extra'}

			let headerLabel = Object.values(headersTemp).map((x)=>{
                    return {
                        v: x.label,  t: 's', s: {  font: { sz: 12, bold: true } } }
                    }
                );
            headerLabel.unshift({
                v: "Id",  t: 's', s: {  font: { sz: 12, bold: true } } 
            })
            headerLabel.unshift({
                v: "No",  t: 's', s: {  font: { sz: 12, bold: true } } 
            })

            headerLabel.push( { v: 'Wilayah',  t: 's', s: {  font: { sz: 12, bold: true } } } )
            headerLabel.push( { v: 'Status',  t: 's', s: {  font: { sz: 12, bold: true } } } )

            datas.push(headerLabel)
            const startData = datas.length
            /* console.log('row1', headerLabel) */

            const headerConfigs =  Object.values(this.headerPreviewMapped)
			let keys = headerConfigs.map((x)=>x.column);
			let fields = headerConfigs.map((x)=>x.id);
			
            const styleSuccess = {  fill: { fgColor: { rgb: '5ebd3e' } }}
            const styleWarning = {  fill: { fgColor: { rgb: 'f78200' } }}

			const ArrayExcel = this.form.factorySourceData.map((x, indexData)=>{
                const dataFormatted = []
                const matched = this.getClassRow(indexData)=='table-success'
                const styleSelected = matched ? styleSuccess: styleWarning

                dataFormatted.push({v: indexData+1, s: styleSelected})
                dataFormatted.push({v: x.row_number, s: styleSelected})
                
                for (let index = 0; index < headerConfigs.length; index++) {
                    const headerConfig = headerConfigs[index];
                    const format  = ['tara','bruto', 'netto','potongan','netto_first', 'driver_price', 'price', 'price_extra'].includes(headerConfig.id)? 'n': 's'
                    const value =  {v: x[headerConfig.column]||x.payment_selected[headerConfig.column]||0, t: format,  s: styleSelected}
                    
                    // if (['tara','bruto', 'netto','potongan','netto_first', 'driver_price'].includes(headerConfig.id)) {
                    //     value.v = value.v
                    //     value.t = 'n'
                    // }
                    // console.log('value', value)
                    dataFormatted.push(value)
                }
                dataFormatted.push(x?.payment_selected?.field?.name||0)
                // if (x.payment_selected||false) {
                //     dataFormatted.push({v: x.payment_selected.driver_price, s: styleSelected})
                //     dataFormatted.push({v: x.payment_selected.price, s: styleSelected})
                //     dataFormatted.push({v: x.payment_selected.price_extra, s: styleSelected})
                // }
                dataFormatted.push(matched?'matched': "not match")
                datas.push(dataFormatted)

                return dataFormatted;
            });

            // datas.push([{ v: 'Data Db',  t: 's', s: {  font: { sz: 13, bold: true } } } ])

            const labelDbNumberROw = datas.length
            const ArrayDB = Object.values(this.paymentsNew).map((grouppedPayment, index)=>{
                const x = grouppedPayment[0]
                const dataFormatted = []
                
                const matched = this.spreadsheetMatch.includes(parseInt(x.id))

                if (matched) {
                    return 
                }

                const styleSelected = matched?styleSuccess:{}
                dataFormatted.push({v: index+1, s: styleSelected})
                dataFormatted.push({v: x.id, s: styleSelected})
                for (let index = 0; index < headerConfigs.length; index++) {
                    const headerConfig = headerConfigs[index];
                    const format  = ['tara','bruto', 'netto','potongan','netto_first', 'driver_price', 'price', 'price_extra'].includes(headerConfig.id)? 'n': 's'
                    const value = { v: x[headerConfig.id], t: format, s: styleSelected}
                    if (headerConfig.id) {
                        dataFormatted.push(value)
                    }
                }
                
                // dataFormatted.push( { v: x.driver_price, t: 'n', s: styleSelected, })
                // dataFormatted.push( { v: x.price, t: 'n', s: styleSelected, })
                // dataFormatted.push( { v: x.price_extra, t: 'n', s: styleSelected, })

                /* 
                const templateMoney = ['FARMER', 'DRIVER', 'FARMER-EXTRA-PAYMENT', 'PAYMENT_GROUP', 'PAYMENT_GROUP-EXTRA-PAYMENT']
                for (let index = 0; index < templateMoney.length; index++) {
                    const financeTag = templateMoney[index];
                    if (x.finance_index[financeTag]) {
                        const value = { v: parseFloat(x.finance_index[financeTag].money),  s: styleSelected}
                        value.z = '#,##0'
                        value.t = 'n'
                        dataFormatted.push(value)
                    }else{
                        dataFormatted.push(0)

                    }
                } 
                */
                dataFormatted.push(x.field?.name||'-')
                dataFormatted.push(matched?'matched': "Not match")
                datas.push(dataFormatted)
                return dataFormatted;
            });

			const ws = XLSX.utils.aoa_to_sheet(datas);
            /* ws["G10"].z = '#,##0'; */
            const configWidthColumns = fields.map(x=>{
                if (['tara','bruto', 'netto','potongan','netto_first'].includes(x)) {
                    return { width: 15 }
                }
                return { width: 20 }
            })
            configWidthColumns.unshift({ width: 7 })
            configWidthColumns.unshift({ width: 5 })
			ws['!cols'] = configWidthColumns

            const rangeSheetNumber = `G${startData+1}:J${datas.length+1}`
            /* console.log('rangeSheetNumber', rangeSheetNumber) */
            var rangeNumber = XLSX.utils.decode_range(rangeSheetNumber);
            /* console.log('rangeNumber', rangeNumber) */
                
            for(var R = rangeNumber.s.r; R <= rangeNumber.e.r; ++R) {
                for(var C = rangeNumber.s.c; C <= rangeNumber.e.c; ++C) {
                    var addr = XLSX.utils.encode_cell({r:R, c:C});
                    /* console.log("addr : ", addr) */
                    if(!ws[addr]) continue;
                    ws[addr].z = '#,##0'; 
                }
            }
            
            const rangeSheetDate = `F${startData+1}:F${datas.length+1}`
            var rangeDate = XLSX.utils.decode_range(rangeSheetDate);
                
            for(var R = rangeDate.s.r; R <= rangeDate.e.r; ++R) {
                for(var C = rangeDate.s.c; C <= rangeDate.e.c; ++C) {
                    var addr = XLSX.utils.encode_cell({r:R, c:C});
                    /* console.log('addr date', addr); */
                    if(!ws[addr]) continue;
                    ws[addr].z = 'dd/mm/yyyy'; 
                }
            }

            // XLSX.utils.sheet_add_aoa(ws, [['foo']], {origin: 'B1'});
            ws["!merges"] =[ 
                { s: { r: 0, c: 0 }, e: { r: 0, c: headerLabel.length } },
                // { s: { r: labelDbNumberROw-1, c: 0 }, e: { r: labelDbNumberROw-1, c: headerLabel.length } }
            ];
			XLSX.utils.book_append_sheet(wb, ws, 'Comparation '+this.form.read_sheet);
			/* XLSX.utils.book_append_sheet(wb, ws, 'Sheet2 '+this.form.read_sheet); */
			XLSX.writeFile(wb, "Comparation Xlsx - Db "+this.formatDate(null, null)+" .xlsx");
        }
        
    },
    props: {
        headersImport:{
            type: Array,
            default:[
            ]
        },
        actionUpload:{
            type: String,
            default:""
        },
        urlFileLocation:{
            type: String,
            default:""
        },
        urlReadFile:{
            type: String,
            default:""
        },
        fileSelected:{
            type: Number,
            default:0
        },
        urlPayment: {
            type: String,
            default: ''
        },
    },
    mounted: function () {  
        this.getFileSelected()
        this.form.column_maps = this.headersImport
        this.headerPreview = this.headersImport
        const column_name =  this.headersImport.map(function(value,index) { return value.id; });
        this.headerPreviewMapped = this.arrayCombine(column_name,  this.headersImport);
    },
    watch: {
    },
});